<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    heading="Edit Threshold Enforcement"
    :width="drawerWidths.lg"
    v-if="visible"
    :loading="loading"
    data-testid="tasklist__bulk-threshold-enforcement-drawer"
  >
    <template v-slot:body>
      <div
        class="d-flex align-center threshold-count-badge mb-3 gap-120"
        data-testid="tasklist__bulk-threshold-enforcement-count-badge"
      >
        <h6 class="font-weight-medium threshold-count-label">Selected</h6>
        <h3 class="font-weight-medium">{{ selectedTasks.length }}</h3>
      </div>

      <div class="threshold-task-table" data-testid="tasklist__bulk-threshold-enforcement-table">
        <v-simple-table dense>
          <template v-slot:default>
            <thead class="tableHeaderBg">
              <tr>
                <th class="tableHeaderBg text-left" scope="col" colspan="2">Selected Tasks</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(task, idx) in selectedTasks"
                :key="task._id || idx"
                data-testid="tasklist__bulk-threshold-enforcement-table-row"
              >
                <td>{{ task.ref || '-' }}</td>
                <td>{{ task.description || '-' }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <p class="font-weight-medium mb-2 mt-3">Action to apply</p>
      <v-row no-gutters class="all-width">
        <v-col cols="6" class="pr-2">
          <v-card
            outlined
            :class="['enable-disable-radio-card pa-3', enforceThreshold === true ? 'enable-disable-radio-card--selected' : '']"
            @click="$emit('update:enforceThreshold', true)"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2 flex-shrink-0" :color="enforceThreshold === true ? 'primary' : 'grey lighten-1'">
                {{ enforceThreshold === true ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
              </v-icon>
              <div>
                <p class="font-weight-medium mb-0">Enable Threshold Enforcement</p>
                <p class="text-caption grey--text mb-0">Re-apply standard validation</p>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="6" class="pl-2">
          <v-card
            outlined
            :class="['enable-disable-radio-card pa-3', enforceThreshold === false ? 'enable-disable-radio-card--selected' : '']"
            @click="$emit('update:enforceThreshold', false)"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2 flex-shrink-0" :color="enforceThreshold === false ? 'primary' : 'grey lighten-1'">
                {{ enforceThreshold === false ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
              </v-icon>
              <div>
                <p class="font-weight-medium mb-0">Disable Threshold Enforcement</p>
                <p class="text-caption grey--text mb-0">Skip attachment + threshold Validation</p>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <div class="d-flex align-start ru-info-banner mt-3 pa-3 radius-small">
        <v-icon class="mr-2 flex-shrink-0" color="primary" small>mdi-information-outline</v-icon>
        <span class=""
          >Only <strong>Account Reconciliation</strong> tasks in <strong>Pending Submission</strong> can be updated.
          Ineligible tasks in your selection — including <strong>Pending Approval</strong>, <strong>Approved</strong>,
          <strong>Auto Approved</strong>, <strong>Blocked</strong>, and non-reconciliation tasks — will be ignored.
          Tasks already set to the selected value are left unchanged. This action is audit-logged.</span
        >
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn
        class="secondaryBtn"
        @click="$emit('cancel')"
        data-testid="tasklist__bulk-threshold-enforcement-cancel-btn"
      >
        <span>Cancel</span>
      </v-btn>
      <v-btn
        color="primary"
        class="ml-2"
        @click="$emit('confirm')"
        data-testid="tasklist__bulk-threshold-enforcement-update-btn"
      >
        <span>Review & Apply</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
import './BulkThresholdDrawer.scss';
import { drawerWidths } from '../../../../../../../styles/design-tokens.js';

export default {
  name: 'BulkThresholdDrawer',
  data() {
    return { drawerWidths };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedTasks: {
      type: Array,
      default: () => [],
    },
    enforceThreshold: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
